import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '../../../../base/components/Flex';
import { useChangeUserLanguage } from '../../../../hooks/useChangeUserLanguage';
import { languageIcons } from '../../../../layouts/ClientLayout/ClientSettingsMenu';
import { LANGUAGES } from '../../../../lib/constants';

const QrLanguageSelector = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t, i18n } = useTranslation();
  const [handleLanguageChange] = useChangeUserLanguage();

  const availableLanguages = LANGUAGES.filter((l) => l !== i18n.language);

  const onLanguageChangeClick = (lang: string) => {
    handleLanguageChange(lang);
    setAnchorEl(null);
  };

  const renderLanguageMenuItem = ({
    lang,
    onClick,
    expanded,
  }: {
    lang: string;
    onClick: () => void;
    expanded?: boolean;
  }) => {
    return (
      <MenuItem key={lang} onClick={onClick}>
        <ListItemIcon
          sx={{
            fontSize: '1.5rem',
          }}
        >
          {languageIcons[lang]}
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            color: 'grey.900',
          }}
        >
          {t(`enum.language.${lang}`, lang)}
        </ListItemText>
        {typeof expanded === 'boolean' && (
          <ListItemIcon
            sx={{
              fontSize: '1.5rem',
              color: 'primary.main',
            }}
          >
            {expanded ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          </ListItemIcon>
        )}
      </MenuItem>
    );
  };

  return (
    <Flex>
      <Button
        id="language-select"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        variant="text"
        size="medium"
        startIcon={languageIcons[i18n.language]}
        sx={{
          color: 'black',
          padding: 1,
        }}
      >
        {t(`enum.language.${i18n.language}`, i18n.language)}
      </Button>
      <Menu
        id="language-select-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {availableLanguages.map((lang) =>
          renderLanguageMenuItem({
            lang: lang,
            onClick: () => onLanguageChangeClick(lang),
          }),
        )}
      </Menu>
    </Flex>
  );
};

export default QrLanguageSelector;
